module.exports = __webpack_public_path__ + "img/gasIcon.43ef0d17.jpeg";